import { promoEventConfig } from '../config';
import { useIsPromoEventActive } from './useIsPromoEventActive';

export const useIsPromoEventBannerActive = () => {
	const active = useIsPromoEventActive();

	return active && !!promoEventConfig.gridBanner;
};
